import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';
import backgroundPlaceHolder from "../assets/about-us-bg-min-7c5f45da.png";
import LazyImage from '../Atoms/LazyImage.js';
import Typography from '../Atoms/Typography.js';
import Button from '../Atoms/Button.js';
import { useTranslation } from 'react-i18next';

function AboutUsOne(_a) {
    var classes = _a.classes, image = _a.image, description = _a.description, _b = _a.backgroundImage, backgroundImage = _b === void 0 ? backgroundPlaceHolder : _b, onReadMoreClick = _a.onReadMoreClick, imageComponent = _a.imageComponent;
    var t = useTranslation().t;
    var handleReadMoreClick = function () {
        onReadMoreClick && onReadMoreClick();
    };
    return (React__default.createElement("div", { style: { backgroundImage: "url(".concat(backgroundImage, ")") }, className: classNames('about-us-one', classes) },
        React__default.createElement("div", { className: "about-us-one__container" },
            React__default.createElement("div", { className: "about-us-one__image-container" },
                React__default.createElement(LazyImage, { src: image, alt: t('landingScreen.aboutUs'), classes: "about-us-one__image", imageComponent: imageComponent })),
            React__default.createElement("div", { className: "about-us-one__content" },
                React__default.createElement(Typography, { classes: "about-us-one__content__title", variant: 'displayText' }, t('landingScreen.aboutUs')),
                React__default.createElement(Typography, { classes: "about-us-one__content__description", variant: 'bodyTextOne' }, description),
                React__default.createElement(Button, { classes: "about-us-one__read-more-button", onClick: handleReadMoreClick, variant: 'link', size: 'md' }, t('landingScreen.readMore'))))));
}

export { AboutUsOne as default };
//# sourceMappingURL=AboutUsOne.js.map
